<template>
    <div class="container">
        <div class="row">
            <img src="../../public/img/404.png" class="w-50 mx-auto my-5 py-5" alt="">
        </div>
    </div>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  components: {},
  setup() {

    return{}
  }
})
</script>